import React from 'react'
import TextLink from 'LuxKit/TextLink'
import Group from 'components/utils/Group'
import LineArrowLeftIcon from 'LuxKit/Icons/line/LineArrowLeftIcon'
import { useScreenSizeUp } from 'hooks/useScreenSize'

interface Props {
  onBack: () => void;
}

function BusinessTravellerLoginBack(props: Props) {
  const { onBack } = props
  const isDesktopUp = useScreenSizeUp('desktop')

  return (
    <Group direction="vertical" style={{ paddingBottom: isDesktopUp ? 40 : 28 }}>
      <TextLink size="medium" onClick={onBack}>
        <Group direction="horizontal" gap={8} verticalAlign="center">
          <LineArrowLeftIcon />Back
        </Group>
      </TextLink>
    </Group>
  )
}

export default BusinessTravellerLoginBack
